export const META_PIXEL_ID = '1639058104314935'

type FbqParams = Record<string, string | number>

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      loaded?: boolean
      version?: string
      push?: unknown
    }
    _fbq?: unknown
  }
}

let initialized = false

/**
 * Injects the Meta Pixel base code once and fires the initial PageView.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  if (!window.fbq) {
    const fbq: Window['fbq'] = function (...args: unknown[]) {
      if (fbq && fbq.callMethod) {
        fbq.callMethod.apply(fbq, args)
      } else if (fbq && fbq.queue) {
        fbq.queue.push(args)
      }
    } as NonNullable<Window['fbq']>

    window.fbq = fbq
    window._fbq = fbq
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const firstScript = document.getElementsByTagName('script')[0]
    firstScript?.parentNode?.insertBefore(script, firstScript)
  }

  window.fbq?.('init', META_PIXEL_ID)
  window.fbq?.('track', 'PageView')
}

export function trackPixelEvent(eventName: string, params?: FbqParams): void {
  if (typeof window === 'undefined') return
  window.fbq?.('track', eventName, params)
}
